import Resource from '@/api/resources/Resource'

class CountryConfigurationServices extends Resource {
    async paginator(filterModel, params) {
        const response = await this.axios.put(`/configuration/countries`, filterModel, { params })
        return response.data
    }
    async patchCountriesBatch(countries) {
        const response = await this.axios.patch(`/configuration/countries/batch`, countries)
        return response.data
    }
    async createCountry(country) {
        const response = await this.axios.post(`/configuration/countries`, country)
        return response.data
    }
    async deleteCountriesBatch(countries) {
        const data = {
            entityIdentifiers: countries
        }
        const response = await this.axios.delete(`/configuration/countries/batch`, { data: data })
        return response.data
    }
}

export default new CountryConfigurationServices()
